import React from "react";
import classnames from "classnames";
import styles from "./TextField.module.scss";
import { Form } from "semantic-ui-react";

interface ITextField extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: any;
  info?: string;
}
const TextField: React.FC<ITextField> = ({
  error,
  type = "text",
  value,
  placeholder,
  onChange,
  info,
  disabled,
  ...inputProps
}) => {
  return (
    <div className={styles.self}>
      <Form.Field>
        <label>{info}</label>
        <input
          type={type}
          className={classnames("form-control form-control-lg", {
            "is-invalid": error,
          })}
          value={value}
          placeholder={placeholder}
          onChange={onChange}
          disabled={disabled}
          {...inputProps}
        />
        {error && <div className="invalid-feedback">{error}</div>}
      </Form.Field>
    </div>
  );
};

export default TextField;
